const t = {
  name: "Email",
  dimensions: { width: 40, height: 33 },
  content: `
    <g clip-path="url(#clip0_12_3891)">
    <path d="M23.95 16.0329L38 3.26293V28.8629L23.95 16.0329ZM17.66 17.2729C18.39 17.6629 19.2 17.8829 20 17.8829C20.81 17.8829 21.61 17.6729 22.34 17.2729L36.28 30.0029H3.72L17.66 17.2729ZM16.05 16.0329L2 28.8629V3.26293L16.05 16.0329ZM22.02 15.0929C20.87 16.1329 19.13 16.1429 17.98 15.0929L3.59 2.00293H36.42L22.02 15.0929ZM38 0.00292969H2C0.9 0.00292969 0 0.90293 0 2.00293V30.0029C0 31.1029 0.9 32.0029 2 32.0029H38C39.1 32.0029 40 31.1029 40 30.0029V2.00293C40 0.90293 39.1 0.00292969 38 0.00292969Z" />
    </g>
    <defs>
    <clipPath id="clip0_12_3891">
    <rect width="40" height="32" fill="currentColor" transform="translate(0 0.00292969)"/>
    </clipPath>
    </defs>

  `
};
export {
  t as Email
};
